import { Button } from "@/components/ui/button";
import { NavLink, NavMenu } from "./nav-menu";
import { NavigationSheet } from "./navigation-sheet";
import React, { useContext } from "react";
import Logo from "../../logo";
import { AuthContext } from "@/contexts";
import { UserProfile } from "@/components/molecules";
import { Link } from "react-router-dom";

export const Navbar = () => {
  const authCtx = useContext(AuthContext);
  const planningCenterSigninURL = `${import.meta.env.VITE_API_BASE_URL}/planning-center/authorize`;

  const navbarLinks: NavLink[] = [
    { name: "Inicio", to: "/" },
    { name: "Estudios", to: "/estudios" },
    { name: "Recursos", to: "/recursos" }
  ]

  if (authCtx.isUserAdmin) {
    navbarLinks.push({ name: 'Usuarios', to: '/gestion-usuarios' });
  }

  return (
    <div className="h-20 overflow-visible">
      <div className="h-[10rem] bg-linear-180 from-gpas-700/70 dark:from-gpas-700/60 to-gpas-700/0"></div>
      <nav className="fixed z-10 top-2 inset-x-4 h-16 bg-background/70 dark:bg-gray-900/80 backdrop-blur-lg border dark:border-slate-700/70 max-w-screen-md mx-auto rounded-full">
        <div className="h-full flex items-center justify-between mx-auto px-4">
          <Link to="/" className="h-full">
            <Logo className="h-full py-5 pl-2 lg:pl-3 text-gpas-700 dark:text-white" />
          </Link>

          {
            authCtx.isAuthenticated &&
            /* Desktop Menu */
            <NavMenu className="hidden md:block" links={navbarLinks} />
          }

          <div className="flex items-center gap-3">
            {
              !authCtx.isAuthenticated ?
                <Button className="rounded-full" asChild>
                  <Link to={planningCenterSigninURL}>
                    Iniciar sesión
                  </Link>
                </Button>
                : authCtx.user &&
                <UserProfile firstname={authCtx.user.firstname} lastname={authCtx.user.lastname} imageURL={authCtx.user?.avatarURL} />
            }

            {
              authCtx.isAuthenticated &&
              /* Mobile Menu */
              <div className="md:hidden">
                <NavigationSheet links={navbarLinks} />
              </div>
            }
          </div>
        </div>
      </nav>
    </div>
  );
};
